import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

type ConsumptionReportOriginal = {
  code: string
  name: string
  employee_no: string
  dep_name: string
  dep_code: string
  benefit_mobile: 'f' | 'n' | 'w' | 'c'
  benefit_mobile_ceiling: number
  tax_report_amount: number
  subscription_amount: number
  one_time_amount: number
  traffic_amount: number
  deduction_amount: number
  total_amount: number
  emne: string
  org_no: number
  company: string
}

const IS_NEW_BACKEND_API = true

export const getConsumptionReports = async ({
  selectedReportType,
  toDate,
  fromDate,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!fromDate || !toDate) throw Error('Missing date range filters!')

  const searchParams = new URLSearchParams()
  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<ConsumptionReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/${selectedReportType}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )

  return mapKeysToCamelCase(reports)
}
